import { useVisitorCanUseCamera } from '@liveHelper/hooks/useVisitorCanUseCamera'
import {
  cameraEnabledSelector,
  isStreamingSelector,
  microphoneMutedSelector,
  useStore,
} from '@liveHelper/models/store'

import {
  LANDSCAPE_VIDEO_TRACK_CONFIG,
  usePublishLocalTrack,
} from '@core/agoraRTC'
import { useAgoraRTCClientContext } from '@core/agoraRTC/contexts/AgoraRTCClientContext'

/**
 * Hook to publish visitor local tracks.
 * @returns The published video track. Undefined if the visitor is not streaming.
 */
export const usePublishVisitorLocalTracks = () => {
  const isMicrophoneMuted = useStore(microphoneMutedSelector)
  const isCameraEnabled = useStore(cameraEnabledSelector)
  const isStreaming = useStore(isStreamingSelector)

  const canUseCamera = useVisitorCanUseCamera()
  const agoraClient = useAgoraRTCClientContext()
  const { videoTrack } = usePublishLocalTrack({
    agoraClient,
    microphoneMuted: isMicrophoneMuted || !isStreaming,
    cameraEnabled: isCameraEnabled && isStreaming && canUseCamera,
    cameraVideoTrackInitConfig: LANDSCAPE_VIDEO_TRACK_CONFIG, // For some reason, even in Portrait mode on mobile, Landscape track config is what we want
  })

  return videoTrack
}
